import type { ColumnsType } from "antd/es/table";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";
import { floatNumberInThousands } from "../../../utils/tools"

const lang = langPage?.card.record;

const renderPrice = (val: number | string) => {
    return floatNumberInThousands(val) || ''
}

export const DEFAULT_QUERY_DATA = {
    Amount: null,
    FromCardHolderEmail: null,
    ToCardHolderEmail: null,
    FromCardNumber: null,
    ToCardNumber: null,
    Daily: null,
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: "金额",
            type: "input",
            field: "Amount",
            allowClear: true,
        },
        {
            title: '转出持卡人邮箱',
            type: "input",
            field: "FromCardHolderEmail",
            allowClear: true,
        },
        {
            title: '转入持卡人邮箱',
            type: "input",
            field: "ToCardHolderEmail",
            allowClear: true,
        },
        {
            title: "转出卡号",
            type: "input",
            field: "FromCardNumber",
            allowClear: true,
        },
        {
            title: "转入卡号",
            type: "input",
            field: "ToCardNumber",
            allowClear: true,
        },
        {
            title: "操作日期",
            type: "datePicker",
            field: "Daily",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    return [
        {
            title: '序号',
            dataIndex: "Index",
            render: (value, record, index) => {
                return index + 1
            }
        },
        {
            title: '转出卡id',
            dataIndex: "FromMemberCardId",
        },
        {
            title: '转出卡号',
            dataIndex: "FromMemberCard",
            render(value, record, index) {
                return record?.FromMemberCard?.UdpayCardNumber ? record?.FromMemberCard.UdpayCardNumber : record?.FromMemberCard?.UdpayMaskedCardNumber
            },
        },
        {
            title: '转出持卡人邮箱',
            dataIndex: "FromCardHolder",
            render(record, index) {
                return record?.Email
            },
        },
        {
            title: '转出用户邮箱',
            dataIndex: "FromMember",
            render(record, index) {
                return record?.Email
            },
        },
        {
            title: '转入卡id',
            dataIndex: "ToMemberCardId",
        },
        {
            title: '转入卡号',
            dataIndex: "ToMemberCardNumber",
        },
        {
            title: '转入持卡人邮箱',
            dataIndex: "ToCardHolder",
            render(record, index) {
                return record?.Email
            },
        },
        {
            title: '转入用户邮箱',
            dataIndex: "ToMember",
            render(record, index) {
                return record?.Email
            },
        },
        {
            title: "转账金额",
            dataIndex: "Amount",
        },
        {
            title: "手续费",
            dataIndex: "CommissionFee",
        },
        {
            title: '实际转账到账',
            dataIndex: "ReceivedAmount",
        },
        {
            title: '状态',
            dataIndex: "StatusString",
        },
        {
            title: "操作日期",
            dataIndex: "Daily",
        },
        {
            title: "操作时间",
            dataIndex: "CreatedAtString",
        },
    ]
}


